export const defaultSorted = [{ dataField: "date", order: "desc" }];
export const sizePerPageList = [
  { text: "10", value: 10 },
  { text: "20", value: 20 },
  { text: "50", value: 30 }
];
export const initialFilter = {
  filter: {},
  sortOrder: "desc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10
};

// Delete Case
export const setNewQueryParams = (queryParams, totalCount, entities) => {
  const pageSize = queryParams.pageSize;
  const lastPageValue = (totalCount + pageSize - 1) / pageSize;
  const pageNumber = queryParams.pageNumber;
  const res = { isRequieredSetQueryParams: lastPageValue === pageNumber && entities.length - 1 === 0 };
  if (res.isRequieredSetQueryParams) {
      res.queryParams = totalCount === 1 ? { ...initialFilter } : { ...queryParams, pageNumber: lastPageValue - 1 };
  }
  return res;
};

export const rowClasses = (row, rowIndex) => {
  return "font-size-lg"
 };